var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"white elevation-2"},[_c('v-toolbar',{staticClass:"blue",attrs:{"flat":"","dense":"","dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.title))]),_vm._t("action")],2),_c('div',{staticClass:"pl-4 pr-4 pt-2 pb-2"},[_vm._t("default",function(){return [_vm._v(" No slot content defined. ")]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }